export const isProd = process.env.REACT_APP_IS_PROD === 'true';

export const siteName = 'H3P';
export const siteUrl = 'https://www.h3p.com';
export const email = 'contact@h3p.com';
export const phone = '01 85 78 09 00';
export const street = '100-101 Terrasse Boieldieu Tour Franklin';
export const postalCode = '92800';
export const city = 'Puteaux';
